var _rect, _rect2, _path, _path2, _rect3, _path3, _path4, _path5, _rect4, _rect5, _rect6, _path6, _path7, _path8, _path9, _path10, _rect7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDash3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 14.5,
    width: 38,
    height: 36,
    rx: 2.5,
    fill: "white",
    stroke: "#9A9FB0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.0081,
    y: 29.2461,
    width: 4.46032,
    height: 4.46032,
    stroke: "url(#paint0_linear)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0398 29.77H41.008",
    stroke: "#27282A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0398 32.8413H36.2303",
    stroke: "#27282A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20.0081,
    y: 39.4841,
    width: 4.46032,
    height: 4.46032,
    stroke: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0398 40.0081H41.008",
    stroke: "#27282A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0398 43.0793H36.2303",
    stroke: "#27282A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 24H51",
    stroke: "#9A9FB0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 11.5,
    width: 3,
    height: 6,
    fill: "white",
    stroke: "#9A9FB0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 42.5,
    y: 11.5,
    width: 3,
    height: 6,
    fill: "white",
    stroke: "#9A9FB0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 31.5,
    y: 36.5,
    width: 25,
    height: 22,
    rx: 1.5,
    fill: "white",
    stroke: "#9A9FB0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36 47.5L40.5 44L43 46L50 40",
    stroke: "url(#paint2_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47 39.5H50.5L50 43",
    stroke: "url(#paint3_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 51C36.5 50.7239 36.7239 50.5 37 50.5H39C39.2761 50.5 39.5 50.7239 39.5 51V53.5H36.5V51Z",
    stroke: "url(#paint4_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 49C42.5 48.7239 42.7239 48.5 43 48.5H45C45.2761 48.5 45.5 48.7239 45.5 49V53.5H42.5V49Z",
    stroke: "url(#paint5_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 46C48.5 45.7239 48.7239 45.5 49 45.5H51C51.2761 45.5 51.5 45.7239 51.5 46V53.5H48.5V46Z",
    stroke: "url(#paint6_linear)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 53,
    width: 18,
    height: 1,
    fill: "url(#paint7_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 19.5081,
    y1: 31.4763,
    x2: 24.5653,
    y2: 32.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4164DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#587CF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 19.5081,
    y1: 41.7143,
    x2: 24.5653,
    y2: 43.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4164DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#587CF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 37.2353,
    y1: 44.5506,
    x2: 47.363,
    y2: 37.8614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4164DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#587CF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 47.3088,
    y1: 41.6236,
    x2: 50.5407,
    y2: 40.4801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4164DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#587CF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 36.3529,
    y1: 52.427,
    x2: 40.0465,
    y2: 51.1201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4164DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#587CF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 42.3529,
    y1: 51.6404,
    x2: 46.2898,
    y2: 50.7118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4164DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#587CF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 48.3529,
    y1: 50.4607,
    x2: 52.4086,
    y2: 49.8229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4164DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#587CF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 36.5882,
    y1: 53.6067,
    x2: 37.0382,
    y2: 50.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4164DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#587CF4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDash3);
export default __webpack_public_path__ + "static/media/dash3.a60f2528223385b497f0dc133f2bf37c.svg";
export { ForwardRef as ReactComponent };